import { postGiftCardQuickPurchaseCreateOrder } from "api"
import SeoMetaData from "common/SeoMetaData"
import KeyboardNavigation from "components/KeyboardNavigation/KeyboardNavigation"
import OtpPage from "components/OtpStep/OtpPage"
import { usePaymentContext } from "components/PurchasePage/Preview/Payment/PaymentContext"
import { usePurchaseContext } from "components/PurchasePage/PurchaseContext"
import { useQuickPurchaseContext } from "components/QuickPurchasePage/QuickPurchaseContext"
import { useRouter } from "next/router"
import { useState } from "react"
import { PaymentSteps } from "../payment"

const seo = {
  title: "Quick Purchase SEO Title",
  description: "Quick Purchase SEO Description",
  keywords: "Quick Purchase SEO Keywords",
}

const QuickPurchaseOtp = () => {
  const [refList] = useState([])
  const [loader, setLoader] = useState(false)
  void loader
  const { quickPurchaseInputValues, setPrevPath } = useQuickPurchaseContext()
  const {
    RecipientEmail,
    RecipientMobilePhone,
    RecipientName,
    SenderEmail,
    SenderLastName,
    SenderMobilePhone,
    SenderName,
    amount,
    checkedTwo,
  } = quickPurchaseInputValues
  const router = useRouter()

  const { setOrderId, setOrderRecipientGuid } = usePurchaseContext()
  const { setPaymentSteps } = usePaymentContext()

  const createOrder = async () => {
    const orderData = {
      quantity: 1,
      amount,
      phoneNumber: RecipientMobilePhone,
      recipientName: RecipientName,
      recipientEmail: RecipientEmail,
      senderName: SenderName,
      senderLastName: SenderLastName,
      senderMobilePhone: SenderMobilePhone,
      senderEmail: SenderEmail,
      senderBlessing: "",
      approveMarketingContent: checkedTwo || false,
    }

    const { data } = await postGiftCardQuickPurchaseCreateOrder(orderData)
    const orderId = data?.body?.orderId
    const orderRecipientGuid = data?.body?.orderRecipientGuid
    setOrderId(orderId)
    setOrderRecipientGuid(orderRecipientGuid)
    router.replace("/quick-purchase/payment")
    setPaymentSteps(PaymentSteps.PAYMENT)
    setLoader(false)

    setPrevPath("/quick-purchase")
  }

  return (
    <>
      <KeyboardNavigation refList={refList} />
      <SeoMetaData data={seo} />
      <OtpPage
        prevPathLink="/quick-purchase"
        editLink="/quick-purchase"
        type="purchase"
        submit={async (success) => {
          if (success) {
            createOrder()
          } else {
            console.log("FAILURE")
          }
        }}
      />
    </>
  )
}

export default QuickPurchaseOtp
